'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('SubscriptionWidgetCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
		$scope.sitekey = (jsMLConfig.recaptcha) ? jsMLConfig.recaptcha.siteKey : null;
		$scope.postUrl = '';
		$scope.message = '';
		$scope.errors = [];
		$scope.subscription = {
			recaptchaResponse: null
		};
		$scope.formSubmitted = false;
		$scope.loading = false;
		$scope.inputTouched = false;

		$scope.clearForm = function () {
			$scope.errors = [];
			$scope.loading = false;
			$scope.subscription.email = "";
			$scope.subscription.terms = false;
			$scope.subscription_form.$setPristine();
		};
		
		$scope.send = function () {
			if (!$scope.sitekey) {
				$scope.loading = true;
				$scope.submit();
				return;
			}
			if (typeof grecaptcha !== 'undefined') {
				grecaptcha.ready(function () {
					if ($scope.sitekey) {
						$scope.loading = true;
						grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
//								document.getElementById('g-recaptcha-response-hidden').value = token;
							$scope.subscription.recaptchaResponse = token;
							$scope.submit();
						});
					} else {
						$scope.loading = false;
						console.log("no recaptcha siteKey");
					}
				});
			} else {
				$scope.loading = false;
				console.log("no recaptcha service");
			}
		};
		$scope.submit = function () {
			if ($scope.postUrl !== '') {
				if (jsMLConfig.recaptcha) {
					$scope.subscription[jsMLConfig.recaptcha.field] = $scope.subscription.recaptchaResponse;
				}

				$http({
					method: 'POST',
					url: $scope.postUrl,
					data: $scope.subscription,
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					if (response.data.data.success) {
						$scope.formSubmitted = true;
						$scope.message = response.data.data.message;
						$scope.clearForm();
					} else if (angular.isDefined(response.data.data.errors)) {
						$scope.loading = false;
						$scope.errors = response.data.data.errors;
					}
					if (angular.isDefined(response.data.data.debug)) {
						$log.debug(response.data.data.debug);
					}
				});
			}
		};
		/*$scope.send = function () {
			if ($scope.postUrl !== '') {
				$scope.loading = true;
				$http({
					method: 'POST',
					url: unescape($scope.postUrl),
					data: $scope.subscription,
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					if (response.data.data.success && typeof response.data.data.message !== 'undefined' && response.data.data.message !== '') {
						$scope.formSubmitted = true;
						$scope.message = response.data.data.message;
						$scope.clearForm();
					} else if (angular.isDefined(response.data.data.errors)) {
						$scope.loading = false;
						$scope.errors = response.data.data.errors;
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};*/
		$scope.searchOnEnter = function (e) {
			$scope.inputTouched = true;
			if (e.which === 13 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
				e.preventDefault();
				$scope.send();
			}
		};
		$scope.hasErrors = function () {
			return $scope.errors.length > 0;
		};
	}]).directive('subscriptionWidgetContainer', [function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.postUrl = '';
            if (attr.postUrl !== '') {
                scope.postUrl = attr.postUrl;
            }
        }
    };
}]);